module.exports = __webpack_public_path__ + "static/media/device-connected.f14476e5.svg";